import moment from 'moment-timezone';
import { CONFIG } from './constants';
import store from '@/store';
export const formatPhoneStringToObject = (v) => {
  if (v) {
    const phoneInfo = v.replace(' ', '');
    const areaCode = this.stripNonNumeric(phoneInfo.substring(0, 2));
    const number = this.stripNonNumeric(phoneInfo.substring(2));
    return {
      countryCode: '+55',
      areaCode,
      number,
    };
  }
  return {
    countryCode: '+55',
    areaCode: '',
    number: '',
  };
};

export const formatPhoneObjectToString = (v) => {
  if (v) {
    const { areaCode, number } = v;
    return areaCode + number;
  } else {
    return '';
  }
};

export const stripNonNumeric = (v) => {
  return v ? v.replace(/\D/g, '') : '';
};

export const formatDocument = (v) => {
  const digits = stripNonNumeric(v);
  if (digits.length === 11) {
    return digits.replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/, '$1.$2.$3-$4');
  } else if (digits.length === 14) {
    return digits.replace(
      /(\d{2})?(\d{3})?(\d{3})?(\d{4})?(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  } else {
    return v;
  }
};

export const formatMoney = (v) => {
  return v || v === 0
    ? `${parseFloat(v).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}`
    : '';
};

export const formatUnifiedValue = (
  v,
  item,
  headerValue,
  expandField = 'slipsUnion'
) => {
  return this.formatMoney(item.contractQty >= 2 ? item[expandField].total : v);
};

export const formatDate = (v) => {
  return v ? moment(v).format('DD/MM/YYYY') : '';
};

export const formatUtcDate = (v) => {
  return v ? moment(v).utc().format('DD/MM/YYYY') : '';
};

export const toDefaultTimezone = (v) => {
  return v
    ? moment.tz(v, store.getters[CONFIG.GET_SHARED].TIMEZONE_LOCATION)
    : moment();
};

export const formatTimezone = (v) => {
  return v ? this.toDefaultTimezone(v).format('YYYY-MM-DDTHH:mm:ss') : '';
};

export const formatDateTime = (v) => {
  return v
    ? moment
        .tz(v, store.getters[CONFIG.GET_SHARED].TIMEZONE_LOCATION)
        .format('DD/MM/YYYY [às] HH:mm')
    : '';
};

export const formatLongDateTime = (v) => {
  if (v) {
    const dateTime = moment.tz(
      v,
      store.getters[CONFIG.GET_SHARED].TIMEZONE_LOCATION
    );
    if (dateTime.utcOffset() === -180) {
      return (
        dateTime.locale('pt').format('DD [de] MMMM [de] YYYY [às] HH:mm') +
        ' (Horário de Brasília)'
      );
    } else {
      return dateTime
        .locale('pt')
        .format('DD [de] MMMM [de] YYYY [às] HH:mm (Z)');
    }
  } else {
    return '';
  }
};

export const formatNotificationDateTime = (v) => {
  if (v) {
    const date = moment(v);
    const diff = moment().diff(v, 'hours');
    if (diff > 23 || diff < 0) {
      return date.format('DD/MM/YYYY');
    } else {
      return `há ${diff > 0 ? diff : `menos de 1`}h`;
    }
  }
};

export const parseMoney = (str) => {
  return parseFloat(str.replace(/[^0-9\.]+/g, ''));
};

export const getArrayMoneyTotal = (value, key) => {
  return this.formatMoney(
    parseFloat(
      value.reduce((sum, o) => (o[key] ? parseFloat(o[key]) + sum : sum), 0)
    )
  );
};

export const parseMoneyComma = (str) => {
  return str ? Number(str.replace(/[^0-9\,]+/g, '').replace(/[\,]+/g, '.')) : 0;
};



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js